import React, { useEffect } from 'react'; // Importe o useEffect
import { ConfigProvider } from 'antd';
import ptBR from 'antd/es/locale/pt_BR';
import { StoreProvider } from './context/StoreContext';
import lightTheme from './themes/lightTheme';
import AppRouter from './routes/AppRouter';
import useIsStoomHostname from 'hooks/useIsStoomHostname';

function App() {

  const { logoFaviconToRender, mainDocumentTitle } = useIsStoomHostname();


  useEffect(() => {
    const favicon = document.querySelector("link[rel~='icon']") as HTMLLinkElement;

    favicon.href = logoFaviconToRender;
    document.title = mainDocumentTitle;

  }, [logoFaviconToRender, mainDocumentTitle]);

  return (
    <StoreProvider>
      <ConfigProvider locale={ptBR} theme={lightTheme}>
        <AppRouter />
      </ConfigProvider>
    </StoreProvider>
  );
}

export default App;